import { AnyAction } from 'redux';

const makeActionCreator = <T extends any[]>(
  type: string,
  ...argNames: string[]
) => (...args: T) => {
  const action: AnyAction = { type };
  argNames.forEach((_, index: number) => {
    action[argNames[index]] = args[index];
  });
  return action;
};

export default makeActionCreator;
